<div class="pb-3">
  {{ (isIssuer ? 'registerIssuer.repDescription' : 'signUp.repDescription') | translate }}
</div>
@if (form && !isLoading) {
  <form (ngSubmit)="submit()" [formGroup]="form" [class.show-form-error]="showFormError">
    <div class="add-issuer-rep">
      @if (repFormControl.controls.length < 3) {
        <div class="btn btn-primary btn-add" (click)="addRep()">
          <i class="fa fa-plus mr-2"></i>{{ 'common.add' | translate }}
        </div>
      }
      <ng-container formArrayName="representatives">
        @for (rep of repFormControl.controls; track rep; let i = $index) {
          <div class="other-rep-panel" [formGroupName]="i">
            @if (isRemoveRepAllowed(i)) {
              <div
                class="pitchin-icon pitchin-icon-delete align-self-end tw-absolute"
                (click)="removeRep(i)"
              ></div>
            }
            <div class="row mb-4">
              <div class="col-md-6 col-sm-12">
                <div class="input-label">{{ 'signUp.identificationType' | translate }}</div>
                <div class="input-field">
                  <mat-select
                    [placeholder]="'common.selectPlaceholder' | translate"
                    class="form-control"
                    formControlName="userIdentityNoType"
                    (selectionChange)="changeIdentificationType(rep)"
                    [disabled]="rep.value.id"
                  >
                    @for (type of IdentificationType | enumToArray; track type) {
                      <mat-option [value]="type.key">
                        {{ 'signUp.' + type.value | translate }}
                      </mat-option>
                    }
                  </mat-select>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12 mb-4">
                <div class="input-label">
                  {{ 'signUp.representativeNameAsPer' | translate }}
                  {{ 'signUp.' + IdentificationType[rep.value.userIdentityNoType] | translate }}
                </div>
                <input
                  type="text"
                  class="form-control"
                  placeholder="{{ 'registerIssuer.namePlaceholder' | translate }}"
                  formControlName="fullName"
                  [readonly]="rep.value.id"
                />
              </div>
              <div class="col-md-6 col-sm-12 mb-4">
                <div class="input-label">
                  {{ 'signUp.' + IdentificationType[rep.value.userIdentityNoType] | translate }}
                  {{ 'signUp.number' | translate }}
                </div>
                <div class="input-field">
                  @if (rep.value.userIdentityNoType != IdentificationType.Passport) {
                    <input
                      class="form-control"
                      placeholder="{{ 'signUp.icNumberPlaceholder' | translate }}"
                      formControlName="identityNo"
                      [mask]="icMaskFormat"
                      type="text"
                      [readonly]="rep.value.id"
                    />
                  }
                  @if (rep.value.userIdentityNoType == IdentificationType.Passport) {
                    <input
                      class="form-control"
                      placeholder="{{ 'signUp.passportPlaceholder' | translate }}"
                      formControlName="identityNo"
                      type="text"
                      [readonly]="rep.value.id"
                      alphanumeric
                    />
                  }
                  @if (
                    showFormError &&
                    rep.controls.identityNo.errors &&
                    (rep.controls.identityNo.errors.pattern || rep.controls.identityNo.errors.mask)
                  ) {
                    <div class="error">
                      {{ 'signUp.' + IdentificationType[rep.value.userIdentityNoType] | translate }}
                      {{ 'signUp.number' | translate }}
                      {{ 'signUp.incorrectFormat' | translate }}
                    </div>
                  }
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-6 col-sm-12">
                <div class="input-label">{{ 'common.email' | translate }}</div>
                <div class="input-field">
                  <input
                    class="form-control"
                    placeholder="{{ 'common.emailPlaceholder' | translate }}"
                    formControlName="email"
                    type="text"
                    maxlength="50"
                    [readonly]="rep.value.id"
                  />
                </div>
                @if (
                  showFormError && rep.controls.email.errors && rep.controls.email.errors.pattern
                ) {
                  <div class="error">
                    {{ 'signUp.emailFormatIncorrect' | translate }}
                  </div>
                }
              </div>
            </div>
          </div>
        }
      </ng-container>
    </div>
    <div class="row pt-5">
      <div class="col-lg-6 col-md-8 input-panel">
        <button type="submit" class="btn btn-primary">
          {{ 'common.update' | translate }}
        </button>
      </div>
    </div>
  </form>
}
@if (isLoading) {
  <agmo-loading></agmo-loading>
}
